import { useForm } from "react-hook-form";
import { useState } from "react";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { ListarGruposController } from "../../../../Controllers/Geral/Grupos/GruposController";
import { InserirContratosCampanhaController } from "../../../../Controllers/Cobranca/DistribuicaoCarteira/DistribuicaoCarteiraControllers";
import { IContrato } from "../../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";

interface IContratosProps {
    setShow: (show: boolean) => void;
    lstCasoCobrancaFato: IContrato[];
    update: () => void;
}

interface IContratosForm extends IContrato {
    ID_GRUPO: number;
    DS_GRUPO: string;
}

export default function AssociarContrato(props: IContratosProps) {
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, setValue } = useForm();

    const handleAtualizarDocumentoFormSubmit = (formdata: IContratosForm) => {
        if (formdata.ID_GRUPO > 0) {
            setLoading(true);
            InserirContratosCampanhaController(
                formdata.ID_GRUPO,
                props.lstCasoCobrancaFato
            ).then((res) => {
                setLoading(false);
                props.setShow(false);
                props.update();
            });
        }
    };
    return (
        <>
            <h4>Distribuir Contratos por Grupo</h4>
            <form
                className="d-flex flex-wrap form-group row"
                onSubmit={handleSubmit(handleAtualizarDocumentoFormSubmit)}
            >
                <div className="col-12 p-0">
                    <LazySelect
                        label="Selecione o grupo abaixo para distribuir os contratos selecionados:"
                        name="ID_GRUPO"
                        ref={register({
                            valueAsNumber: true,
                        })}
                        className="form-control"
                        controller={ListarGruposController}
                        getDS={(p) => p.DS_GRUPO}
                        getKeyValue={(p) => p.ID_GRUPO}
                        setValue={setValue}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                    <button
                        type="submit"
                        className="btn btn-capys font-weight-bold btn-block mt-2"
                        disabled={loading}
                    >
                        Distribuir Contratos
                    </button>
                </div>
            </form>
        </>
    );
}
